module.exports = __webpack_public_path__ + "img/logo2.1c1c4adb.png";